/**
 * BuddyGroupTable — renders the buddy group list in a table.
 */

import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@/components/ui/table';
import type { BuddyGroupSummary } from '../types/buddy-group';
import { getBuddyGroupColumns } from './BuddyGroupTableColumns';

interface BuddyGroupTableProps {
  groups: BuddyGroupSummary[];
  onView: (group: BuddyGroupSummary) => void;
  onEdit: (group: BuddyGroupSummary) => void;
  onDissolve: (group: BuddyGroupSummary) => void;
  canEdit: boolean;
  canDissolve: boolean;
}

export function BuddyGroupTable({
  groups,
  onView,
  onEdit,
  onDissolve,
  canEdit,
  canDissolve,
}: BuddyGroupTableProps) {
  const columns = getBuddyGroupColumns({ onView, onEdit, onDissolve, canEdit, canDissolve });

  return (
    <Table>
      <TableHeader>
        <TableRow>
          {columns.map((col) => (
            <TableHead key={col.key}>{col.header}</TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {groups.map((group) => (
          <TableRow key={group.id} className="cursor-pointer" onClick={() => onView(group)}>
            {columns.map((col) => (
              <TableCell key={col.key} onClick={col.key === 'actions' ? (e) => e.stopPropagation() : undefined}>
                {col.render(group)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
